import script from "./PlatformaVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformaVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./PlatformaVideoPlayer.vue?vue&type=style&index=0&id=555ab3e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555ab3e3"]])

export default __exports__